module.exports = __webpack_public_path__ + "static/media/mon_vieux_grimoire.28a393d2.webp";